export const REQUEST_OBJECT = 'REQUEST_OBJECT';
export const RECEIVE_OBJECT = 'RECEIVE_OBJECT';

// ACTION CREATORS
export const requestObject = data => ({ type: REQUEST_OBJECT, data });
export const receiveObject = data => ({ type: RECEIVE_OBJECT, data });
